// extracted by mini-css-extract-plugin
module.exports = {"icon":"Event_icon__uSlhY","lastSeparator":"Event_lastSeparator__zEp_H"};